module.exports = __webpack_public_path__ + "media/images/icons/skills-development_01-4012097afa13ee37d08d9c956f4e9af6.svg";